var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex "},[(_vm.isEdit)?[_c('select-data-type',{attrs:{"value":_vm.value},on:{"input":function (e){ return _vm.$emit('change',e); }}})]:[_vm._v(" "+_vm._s(_vm.value)+" ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }